import { ErrorHandler, Injectable} from '@angular/core';
import { LoggerService } from '../services/logger.service';


@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private logger: LoggerService)
  {
    super();
  }


  handleError(error: any) {    
    super.handleError(error);
    this.logger.logError(error);
  }
  
}
